import { oids } from "@/configs/Settings";

/**
 * Normaliza o ID da organização para chamadas CRM (CNPJ sem prefixo OID).
 * Aceita prop explícita, contexto de sessão ou OrganizationContext.
 */
export function resolveCrmOrganizationId(
  ...candidates: (string | undefined | null)[]
): string | undefined {
  const prefix = `${oids.cnpj}-`;

  for (const candidate of candidates) {
    const trimmed = candidate?.trim();
    if (!trimmed) continue;
    if (trimmed.startsWith(prefix)) {
      return trimmed.slice(prefix.length);
    }
    return trimmed;
  }

  return undefined;
}
